module.exports = __webpack_public_path__ + "img/invitation_gift1.7a7b39c0.png";